import React, { useRef, useState } from 'react';
import { useHistory, useLocation, useRouteMatch } from 'react-router';

import type { MenuOption } from '@swf/components/Inputs/components/Menu/Menu';
import Menu from '@swf/components/Inputs/components/Menu/Menu';
import StarsButton from '@swf/components/StarsButton/StarsButton';
import Translation from '@swf/components/Translation/Translation';
import useOnClickOutside from '@swf/core/hooks/useOnClickOutside';
import { ClubRoute } from '@swf/core/types/Poker';
import { useGetContentRoutes } from '@swf/poker';

import ChevronIcon from '../assets/chevron.svg';

import { TXTCLI_Club_Settings } from './ActionsDropdown.messages.json';
import styles from './ActionsDropdown.scss';

export enum Action {
  CloseClub,
  LeaveClub
}

const ActionsDropdown: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const history = useHistory();
  const { search } = useLocation();
  const triggerRef = useRef<HTMLDivElement>(null);
  const { clubsPath } = useGetContentRoutes();
  const {
    params: { clubId }
  } = useRouteMatch<{ clubId: string }>();
  const options = [
    {
      text: <Translation {...TXTCLI_Club_Settings} />,
      value: `${clubsPath}/${clubId}/${ClubRoute.Settings}`
    }
  ];

  useOnClickOutside(triggerRef, () => {
    setIsOpen(false);
  });

  const handleSelect = ({ value }: MenuOption) => {
    const pathname = `${value}`;

    history.push({ pathname, search });
  };

  return (
    <div ref={triggerRef} className={styles.container}>
      <StarsButton
        disabled={!options.length}
        variant="text"
        className={styles.button}
        onClick={() => setIsOpen(!isOpen)}
        icon={<ChevronIcon className={styles.icon} width="9" height="6" />}
      />
      {isOpen && options.length > 0 && (
        <Menu className={styles.menu} onSelect={handleSelect} options={options} />
      )}
    </div>
  );
};

export default ActionsDropdown;
